unit unit_EmailEingang;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, strutils,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons, WEBLib.Grids,
  WEBLib.WebCtrls;

type
  TEmailEingang = class(TForm)
    xdsEmails: TXDataWebDataSet;
    xdsEmailsEmailEmpfangenUhrzeit: TDateTimeField;
    xdsEmailsID: TIntegerField;
    xdsEmailsEmailFrom: TStringField;
    xdsEmailsEmailFromName: TStringField;
    xdsEmailsEmailBetreff: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    ResultLabel: TLabel;
    xdsEmailsNurText: TStringField;
    xdsEmailsKundennummer: TStringField;
    edtSuchbegriff: TSearchEdit;
    xdsEmailsBearbeitungsnotiz: TStringField;
    xdsEGesendet: TXDataWebDataSet;
    xdsEGesendetEmailBetreff: TStringField;
    xdsEGesendetKundennummer: TStringField;
    xdsEGesendetgesendetUhrzeit: TDateTimeField;
    xdsEGesendetBearbeitungsnotiz: TStringField;
    xdsEGesendetEmailFrom: TStringField;
    xdsEGesendetEmailFromName: TStringField;
    xdsEGesendetEmailTo: TStringField;
    xdsEGesendetEmailCC: TStringField;
    xdsEGesendetEmailBCC: TStringField;
    xdsEGesendetEmailBody: TStringField;
    xdsEGesendetID: TIntegerField;
    btnPosteingang: TButton;
    btnPostausgang: TButton;
    lblEmailArt: TLabel;
    btnzurueck: TButton;
    xdsEmailsarchiviert: TStringField;
    xdsEGesendetarchiviert: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsEmailsAfterOpen(DataSet: TDataSet);
    procedure ResultLabelClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure edtSuchbegriffSearchClick(Sender: TObject);
    procedure edtSuchbegriffClearClick(Sender: TObject);
    procedure edtSuchbegriffKeyPress(Sender: TObject; var Key: Char);
    procedure btnPostausgangClick(Sender: TObject);
    procedure btnPosteingangClick(Sender: TObject);
    procedure xdsEGesendetAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    EinzelCard:THTMLDiv;
    Posteingang:integer; //0=Eingang //1=Gesendet
    procedure EinzelCardclick(Sender:TObject);
    procedure Ansichterstellen;
  protected procedure LoadDFMValues; override; end;

var
  EmailEingang: TEmailEingang;

implementation
  uses unit1, unit2, unit_EinzelEmail;
{$R *.dfm}

procedure TEmailEingang.Ansichterstellen;
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  if Posteingang=0 then
  begin
    Container3.HTML.Text:='';
    myelement:=container3.ElementHandle;
    lblEmailArt.caption:='Erhaltene Emails';
    xdsEmails.first;
    if xdsEmails.RecordCount=0 then ResultLabel.HTML:='nichts gefunden';
    if xdsEmails.RecordCount>0 then ResultLabel.HTML:='Emails: '+inttostr(xdsEmails.RecordCount);
    if xdsEmails.RecordCount>24 then ResultLabel.HTML:='mehr als 25 Emails <I><U>mehr anzeigen</I></U>';
    if xdsEmails.RecordCount>25 then ResultLabel.HTML:='Emails: '+inttostr(xdsEmails.RecordCount)+' (max. Anzeige: 100)';
    while not xdsEmails.eof do
    begin
      Einzelkarte:='<div class="card-header"><h5>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsEmailsEmailEmpfangenUhrzeit.asdatetime)+'<br>' +xdsEmailsEmailFromName.asstring+' | '+xdsEmailsEmailFrom.asstring+'</h5>';
      Einzelkarte:=Einzelkarte+'Kundennummer: <b>'+xdsEmailsKundennummer.AsString+'</b></div>';
      Einzelkarte:=Einzelkarte+'<div class="card-body "><b>'+xdsEmailsEmailBetreff.AsString+'</b><br>';
      if length(xdsEmailsNurText.asstring)>255 then
      begin
        Einzelkarte:=Einzelkarte+ReplaceStr(leftstr(xdsEmailsNurText.asstring,255),#13+#10,'<BR>')+' ...';
      end
      else
      begin
        Einzelkarte:=Einzelkarte+ReplaceStr(leftstr(xdsEmailsNurText.asstring,255),#13+#10,'<BR>');
      end;

      Einzelkarte:=Einzelkarte+'</div>';
      if xdsEmailsarchiviert.asstring<>'' then
      begin
        Einzelkarte:=Einzelkarte+'<div class="card-footer">archiviert</div>';
      end;
      myelement:=Container3.ElementHandle;
      EinzelCard:=THTMLDiv.Create(self);
      EinzelCard.ElementID:=xdsEmailsID.asstring;
      EinzelCard.Tag:=xdsEmailsID.asinteger;
      EinzelCard.HeightStyle:=ssauto;
      EinzelCard.WidthStyle:=ssPercent;
      EinzelCard.HTML.Text:=Einzelkarte;
      EinzelCard.ElementClassName:='card m-1 border-info';
      EinzelCard.OnClick:=@EinzelCardClick;
      EinzelCard.ParentElement:=myelement;

      xdsEmails.Next;
    end;


  end;
  if Posteingang=1 then
  begin
    Container3.HTML.Text:='';
    myelement:=container3.ElementHandle;
    lblEmailArt.caption:='Gesendete Emails';
    xdsEGesendet.first;
    if xdsEGesendet.RecordCount=0 then ResultLabel.HTML:='nichts gefunden';
    if xdsEGesendet.RecordCount>0 then ResultLabel.HTML:='Emails: '+inttostr(xdsEGesendet.RecordCount);
    if xdsEGesendet.RecordCount>24 then ResultLabel.HTML:='mehr als 25 Emails <I><U>mehr anzeigen</I></U>';
    if xdsEGesendet.RecordCount>25 then ResultLabel.HTML:='Emails: '+inttostr(xdsEGesendet.RecordCount)+' (max. Anzeige: 100)';
    while not xdsEGesendet.eof do
    begin
      Einzelkarte:='<div class="card-header"><h5>'+formatdatetime('DD.MM.YYYY hh:mm:ss',xdsEGesendetgesendetUhrzeit.asdatetime)+'<br>' +xdsEGesendetEmailFromName.asstring+' | '+xdsEGesendetEmailFrom.asstring+'</h5>';
      Einzelkarte:=Einzelkarte+'Kundennummer: <b>'+xdsEGesendetKundennummer.AsString+'</b></div>';
      Einzelkarte:=Einzelkarte+'<div class="card-body "><b>'+xdsEGesendetEmailBetreff.AsString+'</b><br>';
      if length(xdsEGesendetEmailBody.asstring)>255 then
      begin
        Einzelkarte:=Einzelkarte+ReplaceStr(leftstr(xdsEGesendetEmailBody.asstring,255),#13+#10,'<BR>')+' ...';
      end
      else
      begin
        Einzelkarte:=Einzelkarte+ReplaceStr(leftstr(xdsEGesendetEmailBody.asstring,255),#13+#10,'<BR>');
      end;

      Einzelkarte:=Einzelkarte+'</div>';
      if xdsEGesendetarchiviert.asstring<>'' then
      begin
        Einzelkarte:=Einzelkarte+'<div class="card-footer">archiviert</div>';
      end;
      myelement:=Container3.ElementHandle;
      EinzelCard:=THTMLDiv.Create(self);
      EinzelCard.ElementID:=xdsEGesendetID.asstring;
      EinzelCard.Tag:=xdsEGesendetID.asinteger;
      EinzelCard.HeightStyle:=ssauto;
      EinzelCard.WidthStyle:=ssPercent;
      EinzelCard.HTML.Text:=Einzelkarte;
      EinzelCard.ElementClassName:='card m-1 border-info';
      EinzelCard.OnClick:=@EinzelCardClick;
      EinzelCard.ParentElement:=myelement;

      xdsEGesendet.Next;
    end;
  end;
  edtsuchbegriff.SetFocus;
end;

procedure TEmailEingang.btnPostausgangClick(Sender: TObject);
begin
  Posteingang:=1;
  xdsEGesendet.close;
  xdsEGesendet.QueryTop:=25;
  xdsEGesendet.querystring:='$select=ID, gesendetUhrzeit, EmailFromName, EmailFrom, EmailTo, EmailCC, EmailBCC, EmailBetreff, EmailBody, Kundennummer, Bearbeitungsnotiz, archiviert&$orderby=ID DESC';
  xdsEGesendet.load;
end;

procedure TEmailEingang.btnPosteingangClick(Sender: TObject);
begin
  Posteingang:=0;
  xdsEmails.close;
  xdsEmails.QueryTop:=25;
  xdsEmails.QueryString:='$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText, Kundennummer, Bearbeitungsnotiz, archiviert&$filter=archiviert eq null&$orderby=ID DESC';
  xdsEmails.load;
end;

procedure TEmailEingang.btnzurueckClick(Sender: TObject);
begin
  xdsEmails.Close;
  xdsEGesendet.close;
  self.close;
end;

procedure TEmailEingang.edtSuchbegriffClearClick(Sender: TObject);
begin
  edtsuchbegriff.Text:='';
  Container3.HTML.text:='';
  if Posteingang=0 then
  begin
    xdsEmails.Close;
    xdsEmails.QueryTop:=25;
    xdsEmails.QueryString:='$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText, Kundennummer, Bearbeitungsnotiz, archiviert&$filter=archiviert eq null&$orderby=ID DESC';
    xdsEmails.Load;
  end;

  if Posteingang=1 then
  begin
    xdsEGesendet.close;
    xdsEGesendet.QueryTop:=25;
    xdsEGesendet.querystring:='$select=ID, gesendetUhrzeit, EmailFromName, EmailFrom, EmailTo, EmailCC, EmailBCC, EmailBetreff, EmailBody, Kundennummer, Bearbeitungsnotiz, archiviert&$orderby=ID DESC';
    xdsEGesendet.load;
  end;
end;

procedure TEmailEingang.edtSuchbegriffKeyPress(Sender: TObject; var Key: Char);
begin
  if key=#13 then edtSuchbegriffSearchClick(sender);
end;

procedure TEmailEingang.edtSuchbegriffSearchClick(Sender: TObject);
var
  tempsuchtext:string;
begin
  tempsuchtext:=edtsuchbegriff.Text;
  Container3.HTML.text:='';
  if Posteingang=0 then
  begin
    if length(tempsuchtext)>0 then
    begin
      xdsEmails.Close;
      xdsEmails.QueryTop:=25;
      xdsEmails.QueryString:='$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText, Kundennummer, Bearbeitungsnotiz, archiviert&$filter=contains(Kundennummer,'+quotedstr(tempsuchtext)+') OR contains(EmailFrom,'+quotedstr(tempsuchtext)+') OR contains(EmailFromName,'+quotedstr(tempsuchtext)+') OR contains(EmailBetreff,'+quotedstr(tempsuchtext)+')&$orderby=ID DESC';
    end
    else
    begin
      xdsEmails.Close;
      xdsEmails.QueryTop:=25;
      xdsEmails.QueryString:='$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText, Kundennummer, Bearbeitungsnotiz, archiviert&$filter=archiviert eq null&$orderby=ID DESC';
    end;
    xdsEmails.Load;
  end;
  if Posteingang=1 then
  begin
    if length(tempsuchtext)>0 then
    begin
      xdsEGesendet.close;
      xdsEGesendet.QueryTop:=25;
      xdsEGesendet.querystring:='$select=ID, gesendetUhrzeit, EmailFromName, EmailFrom, EmailTo, EmailCC, EmailBCC, EmailBetreff, EmailBody, Kundennummer, Bearbeitungsnotiz, archiviert&$filter=contains(Kundennummer,'+quotedstr(tempsuchtext)+') OR contains(EmailFrom,'+quotedstr(tempsuchtext)+') OR contains(EmailFromName,'+quotedstr(tempsuchtext)+') OR contains(EmailTo,'+quotedstr(tempsuchtext)+') OR contains(EmailBetreff,'+quotedstr(tempsuchtext)+')&$orderby=ID DESC';
    end
    else
    begin
      xdsEGesendet.close;
      xdsEGesendet.QueryTop:=25;
      xdsEGesendet.querystring:='$select=ID, gesendetUhrzeit, EmailFromName, EmailFrom, EmailTo, EmailCC, EmailBCC, EmailBetreff, EmailBody, Kundennummer, Bearbeitungsnotiz, archiviert&$orderby=ID DESC';
    end;
    xdsEGesendet.load;
  end;
end;

procedure TEmailEingang.EinzelCardclick(Sender:TObject);
var
  EinzelEmail:TEinzelEmail;
  MyMerkerEmail:string;
begin
  myMerkerEmail:=inttostr((sender as THTMLDiv).Tag);
  Container3.HTML.text:='';
  EinzelEmail := TEinzelEmail.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelEmail).EmailID:=myMerkerEmail;
      (AForm as TEinzelEmail).Posteingang:=Posteingang;
    end
    );

  EinzelEmail.ShowModal(procedure(AValue: TModalResult)
    begin
      if Posteingang=0 then
      begin
        xdsEmails.close;
        xdsEmails.Load;
      end;
      if Posteingang=1 then
      begin
        xdsEGesendet.close;
        xdsEGesendet.Load;
      end;
    end
    );
end;

procedure TEmailEingang.ResultLabelClick(Sender: TObject);
begin
  if Pos('mehr anzeigen',resultlabel.html,0)>1 then
  begin
    Container3.HTML.text:='';
    if Posteingang=0 then
    begin
      xdsEmails.close;
      xdsEmails.QueryTop:=101;
      xdsEmails.Load;
    end;
    if Posteingang=1 then
    begin
      xdsEGesendet.close;
      xdsEGesendet.QueryTop:=101;
      xdsEGesendet.Load;
    end;
  end;
end;

procedure TEmailEingang.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Emails</h5></nav>';
  myelement:=Container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnPosteingang.ParentElement:=myelement;
  btnPostausgang.ParentElement:=myelement;
  edtSuchbegriff.ParentElement:=myelement;
  ResultLabel.ParentElement:=myelement;
  Container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  lblEmailArt.ParentElement:=myelement;
  btnPosteingangClick(Sender);
end;

procedure TEmailEingang.xdsEGesendetAfterOpen(DataSet: TDataSet);
begin
  Posteingang:=1;
  Ansichterstellen;
end;

procedure TEmailEingang.xdsEmailsAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
begin
  Posteingang:=0;
  Ansichterstellen;
end;

procedure TEmailEingang.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  lblEmailArt := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  edtSuchbegriff := TSearchEdit.Create(Self);
  btnPosteingang := TButton.Create(Self);
  btnPostausgang := TButton.Create(Self);
  btnzurueck := TButton.Create(Self);
  xdsEmails := TXDataWebDataSet.Create(Self);
  xdsEmailsEmailEmpfangenUhrzeit := TDateTimeField.Create(Self);
  xdsEmailsID := TIntegerField.Create(Self);
  xdsEmailsEmailFrom := TStringField.Create(Self);
  xdsEmailsEmailFromName := TStringField.Create(Self);
  xdsEmailsEmailBetreff := TStringField.Create(Self);
  xdsEmailsNurText := TStringField.Create(Self);
  xdsEmailsKundennummer := TStringField.Create(Self);
  xdsEmailsBearbeitungsnotiz := TStringField.Create(Self);
  xdsEmailsarchiviert := TStringField.Create(Self);
  xdsEGesendet := TXDataWebDataSet.Create(Self);
  xdsEGesendetEmailBetreff := TStringField.Create(Self);
  xdsEGesendetKundennummer := TStringField.Create(Self);
  xdsEGesendetgesendetUhrzeit := TDateTimeField.Create(Self);
  xdsEGesendetBearbeitungsnotiz := TStringField.Create(Self);
  xdsEGesendetEmailFrom := TStringField.Create(Self);
  xdsEGesendetEmailFromName := TStringField.Create(Self);
  xdsEGesendetEmailTo := TStringField.Create(Self);
  xdsEGesendetEmailCC := TStringField.Create(Self);
  xdsEGesendetEmailBCC := TStringField.Create(Self);
  xdsEGesendetEmailBody := TStringField.Create(Self);
  xdsEGesendetID := TIntegerField.Create(Self);
  xdsEGesendetarchiviert := TStringField.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  lblEmailArt.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  btnPosteingang.BeforeLoadDFMValues;
  btnPostausgang.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  xdsEmails.BeforeLoadDFMValues;
  xdsEmailsEmailEmpfangenUhrzeit.BeforeLoadDFMValues;
  xdsEmailsID.BeforeLoadDFMValues;
  xdsEmailsEmailFrom.BeforeLoadDFMValues;
  xdsEmailsEmailFromName.BeforeLoadDFMValues;
  xdsEmailsEmailBetreff.BeforeLoadDFMValues;
  xdsEmailsNurText.BeforeLoadDFMValues;
  xdsEmailsKundennummer.BeforeLoadDFMValues;
  xdsEmailsBearbeitungsnotiz.BeforeLoadDFMValues;
  xdsEmailsarchiviert.BeforeLoadDFMValues;
  xdsEGesendet.BeforeLoadDFMValues;
  xdsEGesendetEmailBetreff.BeforeLoadDFMValues;
  xdsEGesendetKundennummer.BeforeLoadDFMValues;
  xdsEGesendetgesendetUhrzeit.BeforeLoadDFMValues;
  xdsEGesendetBearbeitungsnotiz.BeforeLoadDFMValues;
  xdsEGesendetEmailFrom.BeforeLoadDFMValues;
  xdsEGesendetEmailFromName.BeforeLoadDFMValues;
  xdsEGesendetEmailTo.BeforeLoadDFMValues;
  xdsEGesendetEmailCC.BeforeLoadDFMValues;
  xdsEGesendetEmailBCC.BeforeLoadDFMValues;
  xdsEGesendetEmailBody.BeforeLoadDFMValues;
  xdsEGesendetID.BeforeLoadDFMValues;
  xdsEGesendetarchiviert.BeforeLoadDFMValues;
  try
    Name := 'EmailEingang';
    Width := 514;
    Height := 438;
    Caption := 'Suchbegriff eingeben';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 8;
    ResultLabel.Top := 200;
    ResultLabel.Width := 60;
    ResultLabel.Height := 15;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-2';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssAuto;
    ResultLabel.WidthPercent := 100.000000000000000000;
    SetEvent(ResultLabel, Self, 'OnClick', 'ResultLabelClick');
    lblEmailArt.SetParentComponent(Self);
    lblEmailArt.Name := 'lblEmailArt';
    lblEmailArt.Left := 8;
    lblEmailArt.Top := 179;
    lblEmailArt.Width := 58;
    lblEmailArt.Height := 15;
    lblEmailArt.Caption := 'lblEmailArt';
    lblEmailArt.ElementClassName := 'h3 m-2';
    lblEmailArt.ElementFont := efCSS;
    lblEmailArt.HeightStyle := ssAuto;
    lblEmailArt.HeightPercent := 100.000000000000000000;
    lblEmailArt.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.ElementClassName := 'container-fluid rounded';
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 221;
    edtSuchbegriff.Width := 250;
    edtSuchbegriff.Height := 23;
    edtSuchbegriff.AutoSelect := False;
    edtSuchbegriff.AutoSize := True;
    edtSuchbegriff.ChildOrder := 7;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 100.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnKeyPress', 'edtSuchbegriffKeyPress');
    SetEvent(edtSuchbegriff, Self, 'OnClearClick', 'edtSuchbegriffClearClick');
    SetEvent(edtSuchbegriff, Self, 'OnSearchClick', 'edtSuchbegriffSearchClick');
    btnPosteingang.SetParentComponent(Self);
    btnPosteingang.Name := 'btnPosteingang';
    btnPosteingang.Left := 110;
    btnPosteingang.Top := 141;
    btnPosteingang.Width := 96;
    btnPosteingang.Height := 25;
    btnPosteingang.Caption := 'Erhalten';
    btnPosteingang.ChildOrder := 4;
    btnPosteingang.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnPosteingang.ElementFont := efCSS;
    btnPosteingang.ElementPosition := epIgnore;
    btnPosteingang.HeightStyle := ssAuto;
    btnPosteingang.HeightPercent := 100.000000000000000000;
    btnPosteingang.WidthStyle := ssAuto;
    btnPosteingang.WidthPercent := 100.000000000000000000;
    SetEvent(btnPosteingang, Self, 'OnClick', 'btnPosteingangClick');
    btnPostausgang.SetParentComponent(Self);
    btnPostausgang.Name := 'btnPostausgang';
    btnPostausgang.Left := 212;
    btnPostausgang.Top := 141;
    btnPostausgang.Width := 96;
    btnPostausgang.Height := 25;
    btnPostausgang.Caption := 'Gesendet';
    btnPostausgang.ChildOrder := 4;
    btnPostausgang.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnPostausgang.ElementFont := efCSS;
    btnPostausgang.ElementPosition := epIgnore;
    btnPostausgang.HeightStyle := ssAuto;
    btnPostausgang.HeightPercent := 100.000000000000000000;
    btnPostausgang.WidthStyle := ssAuto;
    btnPostausgang.WidthPercent := 100.000000000000000000;
    SetEvent(btnPostausgang, Self, 'OnClick', 'btnPostausgangClick');
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 8;
    btnzurueck.Top := 141;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-sm bg-info m-1';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    xdsEmails.SetParentComponent(Self);
    xdsEmails.Name := 'xdsEmails';
    xdsEmails.AfterOpen := xdsEmailsAfterOpen;
    xdsEmails.EntitySetName := 'EmailEingang';
    xdsEmails.Connection := DM2.XDataWebConnection1;
    xdsEmails.QueryString := '$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText&$filter=archiviert eq null&$orderby=ID DESC';
    xdsEmails.Left := 208;
    xdsEmails.Top := 8;
    xdsEmailsEmailEmpfangenUhrzeit.SetParentComponent(xdsEmails);
    xdsEmailsEmailEmpfangenUhrzeit.Name := 'xdsEmailsEmailEmpfangenUhrzeit';
    xdsEmailsEmailEmpfangenUhrzeit.FieldName := 'EmailEmpfangenUhrzeit';
    xdsEmailsID.SetParentComponent(xdsEmails);
    xdsEmailsID.Name := 'xdsEmailsID';
    xdsEmailsID.FieldName := 'ID';
    xdsEmailsID.Required := True;
    xdsEmailsEmailFrom.SetParentComponent(xdsEmails);
    xdsEmailsEmailFrom.Name := 'xdsEmailsEmailFrom';
    xdsEmailsEmailFrom.FieldName := 'EmailFrom';
    xdsEmailsEmailFrom.Size := 250;
    xdsEmailsEmailFromName.SetParentComponent(xdsEmails);
    xdsEmailsEmailFromName.Name := 'xdsEmailsEmailFromName';
    xdsEmailsEmailFromName.FieldName := 'EmailFromName';
    xdsEmailsEmailFromName.Size := 250;
    xdsEmailsEmailBetreff.SetParentComponent(xdsEmails);
    xdsEmailsEmailBetreff.Name := 'xdsEmailsEmailBetreff';
    xdsEmailsEmailBetreff.FieldName := 'EmailBetreff';
    xdsEmailsEmailBetreff.Size := 250;
    xdsEmailsNurText.SetParentComponent(xdsEmails);
    xdsEmailsNurText.Name := 'xdsEmailsNurText';
    xdsEmailsNurText.FieldName := 'NurText';
    xdsEmailsNurText.Size := 255;
    xdsEmailsKundennummer.SetParentComponent(xdsEmails);
    xdsEmailsKundennummer.Name := 'xdsEmailsKundennummer';
    xdsEmailsKundennummer.FieldName := 'Kundennummer';
    xdsEmailsKundennummer.Size := 13;
    xdsEmailsBearbeitungsnotiz.SetParentComponent(xdsEmails);
    xdsEmailsBearbeitungsnotiz.Name := 'xdsEmailsBearbeitungsnotiz';
    xdsEmailsBearbeitungsnotiz.FieldName := 'Bearbeitungsnotiz';
    xdsEmailsBearbeitungsnotiz.Size := 255;
    xdsEmailsarchiviert.SetParentComponent(xdsEmails);
    xdsEmailsarchiviert.Name := 'xdsEmailsarchiviert';
    xdsEmailsarchiviert.FieldName := 'archiviert';
    xdsEmailsarchiviert.Size := 250;
    xdsEGesendet.SetParentComponent(Self);
    xdsEGesendet.Name := 'xdsEGesendet';
    xdsEGesendet.AfterOpen := xdsEGesendetAfterOpen;
    xdsEGesendet.EntitySetName := 'Email';
    xdsEGesendet.Connection := DM2.XDataWebConnection1;
    xdsEGesendet.QueryString := '$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText&$filter=archiviert eq null&$orderby=ID DESC';
    xdsEGesendet.Left := 280;
    xdsEGesendet.Top := 8;
    xdsEGesendetEmailBetreff.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBetreff.Name := 'xdsEGesendetEmailBetreff';
    xdsEGesendetEmailBetreff.FieldName := 'EmailBetreff';
    xdsEGesendetEmailBetreff.Size := 255;
    xdsEGesendetKundennummer.SetParentComponent(xdsEGesendet);
    xdsEGesendetKundennummer.Name := 'xdsEGesendetKundennummer';
    xdsEGesendetKundennummer.FieldName := 'Kundennummer';
    xdsEGesendetKundennummer.Size := 13;
    xdsEGesendetgesendetUhrzeit.SetParentComponent(xdsEGesendet);
    xdsEGesendetgesendetUhrzeit.Name := 'xdsEGesendetgesendetUhrzeit';
    xdsEGesendetgesendetUhrzeit.FieldName := 'gesendetUhrzeit';
    xdsEGesendetBearbeitungsnotiz.SetParentComponent(xdsEGesendet);
    xdsEGesendetBearbeitungsnotiz.Name := 'xdsEGesendetBearbeitungsnotiz';
    xdsEGesendetBearbeitungsnotiz.FieldName := 'Bearbeitungsnotiz';
    xdsEGesendetBearbeitungsnotiz.Size := 255;
    xdsEGesendetEmailFrom.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailFrom.Name := 'xdsEGesendetEmailFrom';
    xdsEGesendetEmailFrom.FieldName := 'EmailFrom';
    xdsEGesendetEmailFrom.Size := 50;
    xdsEGesendetEmailFromName.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailFromName.Name := 'xdsEGesendetEmailFromName';
    xdsEGesendetEmailFromName.FieldName := 'EmailFromName';
    xdsEGesendetEmailFromName.Size := 50;
    xdsEGesendetEmailTo.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailTo.Name := 'xdsEGesendetEmailTo';
    xdsEGesendetEmailTo.FieldName := 'EmailTo';
    xdsEGesendetEmailTo.Size := 255;
    xdsEGesendetEmailCC.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailCC.Name := 'xdsEGesendetEmailCC';
    xdsEGesendetEmailCC.FieldName := 'EmailCC';
    xdsEGesendetEmailCC.Size := 255;
    xdsEGesendetEmailBCC.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBCC.Name := 'xdsEGesendetEmailBCC';
    xdsEGesendetEmailBCC.FieldName := 'EmailBCC';
    xdsEGesendetEmailBCC.Size := 255;
    xdsEGesendetEmailBody.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBody.Name := 'xdsEGesendetEmailBody';
    xdsEGesendetEmailBody.FieldName := 'EmailBody';
    xdsEGesendetEmailBody.Size := 255;
    xdsEGesendetID.SetParentComponent(xdsEGesendet);
    xdsEGesendetID.Name := 'xdsEGesendetID';
    xdsEGesendetID.FieldName := 'ID';
    xdsEGesendetID.Required := True;
    xdsEGesendetarchiviert.SetParentComponent(xdsEGesendet);
    xdsEGesendetarchiviert.Name := 'xdsEGesendetarchiviert';
    xdsEGesendetarchiviert.FieldName := 'archiviert';
    xdsEGesendetarchiviert.Size := 250;
  finally
    ResultLabel.AfterLoadDFMValues;
    lblEmailArt.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    btnPosteingang.AfterLoadDFMValues;
    btnPostausgang.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    xdsEmails.AfterLoadDFMValues;
    xdsEmailsEmailEmpfangenUhrzeit.AfterLoadDFMValues;
    xdsEmailsID.AfterLoadDFMValues;
    xdsEmailsEmailFrom.AfterLoadDFMValues;
    xdsEmailsEmailFromName.AfterLoadDFMValues;
    xdsEmailsEmailBetreff.AfterLoadDFMValues;
    xdsEmailsNurText.AfterLoadDFMValues;
    xdsEmailsKundennummer.AfterLoadDFMValues;
    xdsEmailsBearbeitungsnotiz.AfterLoadDFMValues;
    xdsEmailsarchiviert.AfterLoadDFMValues;
    xdsEGesendet.AfterLoadDFMValues;
    xdsEGesendetEmailBetreff.AfterLoadDFMValues;
    xdsEGesendetKundennummer.AfterLoadDFMValues;
    xdsEGesendetgesendetUhrzeit.AfterLoadDFMValues;
    xdsEGesendetBearbeitungsnotiz.AfterLoadDFMValues;
    xdsEGesendetEmailFrom.AfterLoadDFMValues;
    xdsEGesendetEmailFromName.AfterLoadDFMValues;
    xdsEGesendetEmailTo.AfterLoadDFMValues;
    xdsEGesendetEmailCC.AfterLoadDFMValues;
    xdsEGesendetEmailBCC.AfterLoadDFMValues;
    xdsEGesendetEmailBody.AfterLoadDFMValues;
    xdsEGesendetID.AfterLoadDFMValues;
    xdsEGesendetarchiviert.AfterLoadDFMValues;
  end;
end;

end.
